@if (loading) {
  <div
    [ngClass]="{ block: !overlay && !fixed }"
    [ngStyle]="{ 'background-color': bgColor }"
  >
    <div
      [ngClass]="{
        overlay: overlay,
        'overlay-fixed': fixed,
        'overlay-light': overlayLight,
      }"
    >
      <mat-progress-spinner
        class="spinner"
        [color]="color"
        [mode]="mode"
        [value]="value"
      ></mat-progress-spinner>
    </div>
  </div>
}
